export default __webpack_public_path__ + "static/waffles-b3fb924dd7096ce1a7235dcdf7f11fc2.svg";